import { render, staticRenderFns } from "./BrandSignature.vue?vue&type=template&id=6f2f3450&scoped=true&"
import script from "./BrandSignature.vue?vue&type=script&lang=js&"
export * from "./BrandSignature.vue?vue&type=script&lang=js&"
import style0 from "./BrandSignature.vue?vue&type=style&index=0&id=6f2f3450&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2f3450",
  null
  
)

export default component.exports